import { graphql } from "gatsby"
import get from "lodash.get"
import LocalizedLink from "components/LocalizedLink"
import useTranslations from "hooks/useTranslations"
import { formatCases } from "utils/prismic"
import ContentPageContainer from "components/molecules/common/ContentPageContainer"
import Tag from "components/atoms/Tag"
import { GatsbyImage } from "gatsby-plugin-image"

function ListItem({ item }) {
  const { quoteMore } = useTranslations()

  return (
    <LocalizedLink to={`${item.slug}`}>
      <article
        aria-labelledby={`episode-${item.id}-title`}
        className="flex space-x-6 py-10 first:pt-0 sm:py-12 first:lg:py-12"
      >
        <GatsbyImage
          image={item.avatar}
          className="my-2 h-20 w-20 shrink-0 rounded-full sm:h-32 sm:w-32"
          imgClassName="aspect-square"
          alt="user-image"
          objectFit="contain"
        />
        <div className="flex flex-col items-start">
          <Tag text={item.tag} theme="light" className="mb-4" />

          <h2
            id={`episode-${item.id}-title`}
            className="mb-0 grow text-left text-2xl text-zinc-800"
          >
            {item.title}
          </h2>

          {item.description ? (
            <p className="m-0 mt-1 text-base leading-7 text-slate-700">
              {item.description}
            </p>
          ) : null}
          <div className="mt-4 flex items-center gap-4">
            <div
              className="flex items-center text-sm font-bold leading-6 text-teal-500 hover:text-teal-700 active:text-teal-900"
              aria-label={`Read case ${item.title}`}
            >
              {quoteMore}
            </div>
          </div>
        </div>
      </article>
    </LocalizedLink>
  )
}

export default function Cases({ data }) {
  const cases = formatCases(get(data, "allPrismicCase", []))
  const { quotesTitle } = useTranslations()
  return (
    <ContentPageContainer title={quotesTitle}>
      <div className="divide-y divide-slate-200 sm:mt-4 lg:mt-8 lg:border-t lg:border-slate-200">
        {cases.map((item) => (
          <ListItem key={item.id} item={item} />
        ))}
      </div>
    </ContentPageContainer>
  )
}

export const query = graphql`
  query ($locale: String!) {
    allPrismicCase(filter: { lang: { eq: $locale } }) {
      nodes {
        lang
        id
        data {
          content {
            richText
          }
          description {
            text
          }
          title {
            text
          }
          quote {
            text
          }
          avatar {
            gatsbyImageData(width: 144)
          }
          index
          slug
          tag
        }
      }
    }
  }
`
